import { THEME_PROTOCOL, THEME_PROTOCOL_VERSION, isRecord } from './tokens';
import type { IThemeMessage } from '../types';

const MESSAGE_TYPES = ['READY', 'APPLY', 'APPLIED', 'RESET'];

/** 只认精确 http(s) origin（不含路径、通配符、null origin） */
export function isHttpOrigin(origin: string): boolean {
  try {
    const url = new URL(origin);
    return ['http:', 'https:'].includes(url.protocol) && url.origin === origin;
  } catch {
    return false;
  }
}

/** 环境配置的逗号分隔 origin 列表，非法项丢弃 */
export function parseThemeOrigins(value: unknown): string[] {
  if (typeof value !== 'string') return [];
  return [...new Set(value.split(',').map((entry) => entry.trim()).filter(isHttpOrigin))];
}

/**
 * 校验协议信封；APPLY 的 payload 只要求为对象，
 * 具体 token 由接收端 resolveTheme 逐个严格校验并回退本端默认值，单侧新增 token 不会整包拒收
 */
export function isThemeMessage(value: unknown): value is IThemeMessage {
  return (
    isRecord(value) &&
    value.protocol === THEME_PROTOCOL &&
    value.version === THEME_PROTOCOL_VERSION &&
    MESSAGE_TYPES.includes(value.type as string) &&
    typeof value.sessionId === 'string' &&
    /^[\w-]{1,100}$/.test(value.sessionId) &&
    Number.isSafeInteger(value.requestId) &&
    (value.requestId as number) >= 0 &&
    (value.type !== 'APPLY' || isRecord(value.payload))
  );
}
